import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import ProgramService from '../../services/program';

/**
 * Interface for home feed section
 */
export type HomeFeedSection = {
  id: string;
  type: string;
  attributes: {
    order: number;
    feed: string;
    filter_id: number;
    min_contents: number;
    display_type: 'grid' | 'hero' | 'gallery' | 'row';
  };
};

/**
 * Interface for home feed sections response
 */
export type HomeFeedSectionsResponse = {
  feed_sections: HomeFeedSection[];
};

/**
 * Query key for home feed sections
 */
export const HOME_FEED_SECTIONS_QUERY_KEY = ['homeFeedSections'];

/**
 * Custom hook to fetch home feed sections
 *
 * @param options - Optional React Query options
 * @returns Query result with home feed sections data
 */
export const useHomeFeedSectionsQuery = (
  options?: Omit<
    UseQueryOptions<HomeFeedSection[], Error, HomeFeedSection[], string[]>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<HomeFeedSection[], Error, HomeFeedSection[], string[]>({
    queryKey: HOME_FEED_SECTIONS_QUERY_KEY,
    queryFn: async () => {
      const response = await new ProgramService().fetchFeedSections();
      return response.data.feed_sections;
    },
    ...options,
  });
};
